
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 2800 1400"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#cc0001","d":"M0 0h2800v1400H0z"}}),_c('path',{attrs:{"id":"a","fill":"#fff","d":"M0 1300h2800v100H0z"}}),_c('use',{attrs:{"transform":"translate(0 -200)","xlink:href":"#a"}}),_c('use',{attrs:{"transform":"translate(0 -400)","xlink:href":"#a"}}),_c('use',{attrs:{"transform":"translate(0 -600)","xlink:href":"#a"}}),_c('use',{attrs:{"transform":"translate(0 -800)","xlink:href":"#a"}}),_c('use',{attrs:{"transform":"translate(0 -1000)","xlink:href":"#a"}}),_c('use',{attrs:{"transform":"translate(0 -1200)","xlink:href":"#a"}}),_c('path',{attrs:{"fill":"#010066","d":"M0 0h1400v800H0z"}}),_c('path',{attrs:{"d":"M576 100c-166.146 0-301 134.406-301 300s134.854 300 301 300c60.027 0 115.955-17.564 162.927-47.783-27.353 9.44-56.71 14.602-87.271 14.602-147.327 0-266.897-119.172-266.897-266.01 0-146.837 119.57-266.01 266.897-266.01 32.558 0 63.746 5.815 92.602 16.468C696.217 118.91 638.305 100 576 100z","fill":"#fc0"}}),_c('path',{attrs:{"d":"M1075.167 556.174l-126.79-66.153 37.488 135.389-84.804-113.254L874.605 650l-26.021-137.923-85.162 112.998L801.338 489.8 674.34 555.571l94.343-105.834L625 455.254l132.084-55.431-131.908-55.83 143.664 5.95-94.007-106.117 126.79 66.153-37.488-135.389 84.804 113.254L875.395 150l26.021 137.923 85.162-112.998L948.662 310.2l126.998-65.771-94.343 105.834L1125 344.746l-132.084 55.431 131.908 55.83-143.664-5.95z","fill":"#fc0"}})])
          )
        }
      }
    